/**
 * Limites dos campos baseados na estrutura do banco de dados
 * Extraído do backup: backup_mendes_consorcio_20250529_013513.sql
 */

export const FIELD_LIMITS = {
  // Informações Pessoais
  nome: {
    maxLength: 255,
    label: "Nome Completo",
    placeholder: "Digite o nome completo"
  },
  email: {
    maxLength: 255,
    label: "Email",
    placeholder: "exemplo@email.com"
  },
  cpf: {
    maxLength: 14,
    label: "CPF/CNPJ",
    placeholder: "000.000.000-00 ou 00.000.000/0000-00",
    description: "Digite apenas os números (CPF: 11 dígitos, CNPJ: 14 dígitos)"
  },
  rg: {
    maxLength: 20,
    label: "RG",
    placeholder: "00.000.000-0"
  },
  
  // Telefones
  tel1: {
    maxLength: 16, // Máximo incluindo formatação: (11) 99999-9999
    label: "Telefone Principal",
    placeholder: "(00) 00000-0000"
  },
  tel2: {
    maxLength: 16, // Máximo incluindo formatação: (11) 99999-9999
    label: "Telefone Secundário",
    placeholder: "(00) 00000-0000"
  },
  
  // Informações Complementares
  naturalidade: {
    maxLength: 100,
    label: "Naturalidade",
    placeholder: "Cidade de nascimento"
  },
  nacionalidade: {
    maxLength: 100,
    label: "Nacionalidade",
    placeholder: "Brasileira"
  },
  atividadeDesenvolvida: {
    maxLength: -1, // text (sem limite)
    label: "Atividade Desenvolvida",
    placeholder: "Profissão ou atividade"
  },
  rendimentoTitular: {
    maxLength: -1, // text (sem limite)
    label: "Rendimento do Titular",
    placeholder: "Renda mensal"
  },
  
  // Informações Familiares
  nomeMae: {
    maxLength: 255,
    label: "Nome da Mãe",
    placeholder: "Nome completo da mãe"
  },
  nomePai: {
    maxLength: 255,
    label: "Nome do Pai",
    placeholder: "Nome completo do pai"
  },
  estadoCivil: {
    maxLength: 20,
    label: "Estado Civil",
    placeholder: "Estado civil"
  },
  nomeConjuge: {
    maxLength: 255,
    label: "Nome do Cônjuge",
    placeholder: "Nome completo do cônjuge"
  },
  cpfConjuge: {
    maxLength: 14,
    label: "CPF/CNPJ do Cônjuge",
    placeholder: "000.000.000-00 ou 00.000.000/0000-00",
    description: "Digite apenas os números (CPF: 11 dígitos, CNPJ: 14 dígitos)"
  },
  
  // Dados Bancários
  banco: {
    maxLength: 100,
    label: "Banco",
    placeholder: "Nome do banco"
  },
  agencia: {
    maxLength: 20,
    label: "Agência",
    placeholder: "Número da agência"
  },
  conta: {
    maxLength: 20,
    label: "Conta",
    placeholder: "Número da conta"
  },
  tipoConta: {
    maxLength: 20,
    label: "Tipo de Conta",
    placeholder: "Tipo de conta"
  },
  
  // Endereço
  logradouro: {
    maxLength: 255,
    label: "Logradouro",
    placeholder: "Rua, Avenida, etc."
  },
  numero: {
    maxLength: 20,
    label: "Número",
    placeholder: "Número da residência"
  },
  complemento: {
    maxLength: 255,
    label: "Complemento",
    placeholder: "Apartamento, bloco, etc."
  },
  bairro: {
    maxLength: 100,
    label: "Bairro",
    placeholder: "Nome do bairro"
  },
  cep: {
    maxLength: 8,
    label: "CEP",
    placeholder: "00000-000"
  },
  cidade: {
    maxLength: 100,
    label: "Cidade",
    placeholder: "Nome da cidade"
  },
  estado: {
    maxLength: 2,
    label: "Estado",
    placeholder: "UF"
  },
  
  // Campos para Pessoa Jurídica
  razao_social: {
    maxLength: 255,
    label: "Razão Social",
    placeholder: "Razão social da empresa"
  },
  inscricao_estadual: {
    maxLength: 20,
    label: "Inscrição Estadual",
    placeholder: "Inscrição estadual (se houver)"
  },
  nome_responsavel: {
    maxLength: 255,
    label: "Nome do Responsável",
    placeholder: "Nome completo do responsável"
  },
  cpf_responsavel: {
    maxLength: 11,
    label: "CPF do Responsável",
    placeholder: "000.000.000-00",
    description: "Digite apenas os números (11 dígitos)"
  },
  email_responsavel: {
    maxLength: 255,
    label: "Email do Responsável",
    placeholder: "responsavel@email.com"
  },
  tel_responsavel: {
    maxLength: 16,
    label: "Telefone do Responsável",
    placeholder: "(00) 00000-0000"
  }
} as const;

/**
 * Função para obter o limite de um campo específico
 */
export function getFieldLimit(fieldName: keyof typeof FIELD_LIMITS) {
  return FIELD_LIMITS[fieldName];
}

/**
 * Função para verificar se um campo tem limite de caracteres
 */
export function hasFieldLimit(fieldName: keyof typeof FIELD_LIMITS): boolean {
  const limit = FIELD_LIMITS[fieldName]?.maxLength;
  return limit !== undefined && limit > 0;
}

/**
 * Função para obter o limite máximo de caracteres de um campo
 */
export function getMaxLength(fieldName: keyof typeof FIELD_LIMITS): number | undefined {
  const limit = FIELD_LIMITS[fieldName]?.maxLength;
  return limit && limit > 0 ? limit : undefined;
} 